import React, { useEffect } from "react";
import "./OfflinePrompt.scss";
import { useOffline } from "../../../contexts/OfflineContext";
import { useNavigate } from "react-router-dom";

const OFFLINE_BOOK_KEY = "offline_saved_book";

const OfflinePrompt = () => {
  const { showOfflinePrompt, dismissPrompt, toggleOffline } = useOffline();
  const navigate = useNavigate();

  useEffect(() => {
    if (!showOfflinePrompt) return;
    document.addEventListener("click", dismissPrompt);
    return () => {
      document.removeEventListener("click", dismissPrompt);
    };
  }, [showOfflinePrompt]);

  if (!showOfflinePrompt) return null;

  const handleEnable = () => {
    const stored = localStorage.getItem(OFFLINE_BOOK_KEY);
    toggleOffline();
    dismissPrompt();
    if (stored) {
      const meta = JSON.parse(stored);
      navigate(`/songbook/${meta.id}`);
    }
  };

  return (
    <div className="offline-prompt">
      <p className="offline-prompt__text">
        Здається, немає інтернету. Перейти в офлайн режим?
      </p>
      <div className="offline-prompt__actions">
        <button className="btn-mcolor" onClick={handleEnable}>
          Увімкнути
        </button>
        <button className="btn-plain" onClick={dismissPrompt}>
          Ні, дякую
        </button>
      </div>
    </div>
  );
};

export default OfflinePrompt;
